import {Component,OnInit} from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-agency-signup',
  templateUrl: './agency-signup.component.html',
  styleUrl: './agency-signup.component.scss'
})
export class AgencySignupComponent implements OnInit {
  step: number = 1; // init 1
  loading = false;

  agenceInscriptionFormControl: FormGroup = this.fb.group({
    nomDirigeant: ['', [Validators.required]],
    adresseSiege: [{value:'',disabled: true}, [Validators.required]],
    raisonSociale: [{value:'',disabled: true}, [Validators.required]],
    nomAgence: ['', [Validators.required]],
    siret: ['', [Validators.required,Validators.pattern('^[0-9]{14}$')]],
    agencyEmail: ['', [Validators.required, Validators.email]],
    // email: ['', [Validators.required, Validators.email]], // dirigeant login email -- onboarding now creates a single AGENCY user
    password: [
      '',
      [Validators.required,Validators.pattern(
        '^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*/])[A-Za-z\\d!@#$%^&*/]{8,}$'
      ),],
    ]
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  onSubmit(): any {
    if (this.agenceInscriptionFormControl.valid) {
      console.log(this.agenceInscriptionFormControl.value);
    }
  }
  
}